import React from 'react';
import { getDeviationType } from '../_helpers';
import { DeviationTypes } from '../../types/deviation';
import ImageDumbView from './Image';
import UnknownDumbView from './Unknown';
import ErrorBoundary from '../../ErrorBoundary';
import MiniTextDumbView from './MiniText';
import { useDumboCommon } from './useDumbo';
// This is a variant on the normal dumbo, but without editor deps
// It's only meant to be used in tiny places where the difference is not
// noticeable, eg. the user avatar tooltip's miniscule thumbs
const MinimalDeviationDumbView = (props)=>{
    const DumboReturn = useDumboCommon(props);
    if (DumboReturn) {
        return DumboReturn;
    }
    let DumbView;
    switch(getDeviationType(props.deviation)){
        // these types all have guaranteed thumb image
        case DeviationTypes.IMAGE:
        case DeviationTypes.PDF:
        case DeviationTypes.FILM:
            DumbView = ImageDumbView;
            break;
        case DeviationTypes.JOURNAL:
        case DeviationTypes.LITERATURE:
        case DeviationTypes.STATUS:
        case DeviationTypes.POLL:
        case DeviationTypes.COMMISSION:
            DumbView = MiniTextDumbView;
            break;
        default:
            DumbView = UnknownDumbView;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "MinimalDumbo",
        style: {
            width: props.width,
            height: props.height
        }
    }, /*#__PURE__*/ React.createElement(DumbView, props));
};
MinimalDeviationDumbView.displayName = 'MinimalDeviationDumbView';
export default MinimalDeviationDumbView;
